import { compareAsc } from 'date-fns'
import { differenceBy, pullAllBy } from 'lodash'
import { IRoom } from '../../models/Room'

const roomSort = (prevRooms: IRoom[], nextRooms: IRoom[]) => {
  const missing = differenceBy(prevRooms, nextRooms, 'id')
  const con = prevRooms.concat(nextRooms).sort((a, b) => {
    const result = compareAsc(a.modifiedAt, b.modifiedAt)
    return result === 0 ? a.position - b.position : result
  })
  if (!con.length) return []

  const sorted = new Array(Math.max(prevRooms.length, nextRooms.length)).fill(
    null,
  )
  // sorted.push(con.shift())
  con.forEach(c => {
    const alreadyThere = sorted.findIndex(s => s && s.id === c.id)
    if (alreadyThere > -1) {
      sorted.splice(alreadyThere, 1)
    } else if (!sorted[c.position - 1]) {
      sorted.splice(c.position - 1, 1)
    }
    sorted.splice(c.position - 1, 0, c)
  })
  pullAllBy(sorted, missing, 'id')
  return sorted.filter(s => !!s).map((r, idx) => ({ ...r, position: idx + 1 }))
}

export default roomSort
